import React from "react";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Guild from "./pages/Guild";
import Transportation from "./pages/Transportation";
import Margrave from "./pages/Margrave";
import Vaccination from "./pages/Vaccination";
import Setting from "./pages/Setting";
import SettingProfile from "./pages/SettingProfile";
import SettingFAQ from "./pages/SettingFAQ";
import SettingContactUs from "./pages/SettingContactUs";
import SettingAboutUs from "./pages/SettingAboutUs";
import SettingUserInquiry from "./pages/SettingUserInquiry";
import SettingHealthProtocol from "./pages/SettingHealthProtocol";
import SettingSupport from "./pages/SettingSupport";
import ChatSupport from "./pages/ChatSupport";
import VaccineLicense from "./pages/VaccineLicense";
import VaccineLicenseInternal from "./pages/VaccineLicenseInternal";
import ResultVaccineLicense from "./pages/ResultVaccineLicense";
import {Switch} from "react-router-dom";
import AuthRoute from "./routes/AuthRoute";
import PrivateRoute from "./routes/PrivateRoute";
import ScrollToTop from "./components/scrollToTop";

const App = () => {
  return (
    <>
      <ScrollToTop/>
      <Switch>
        <AuthRoute path="/" exact component={Login}/>
        <PrivateRoute path="/profile" exact component={Profile}/>
        <PrivateRoute path="/guild" exact component={Guild}/>
        <PrivateRoute path="/transportation" exact component={Transportation}/>
        <PrivateRoute path="/margrave" exact component={Margrave}/>
        <PrivateRoute path="/vaccination" exact component={Vaccination}/>
        <PrivateRoute path="/vaccination/vaccine-license" exact component={VaccineLicense}/>
        <PrivateRoute path="/vaccination/vaccine-license-internal" exact component={VaccineLicenseInternal}/>
        <PrivateRoute path="/vaccination/vaccine-license/:id" exact component={ResultVaccineLicense}/>
        {/*<PrivateRoute path="/margrave/travel-permit" exact component={TravelPermit} />*/}
        {/*<PrivateRoute path="/margrave/flight-list" exact component={FlightList} />*/}
        <PrivateRoute path="/setting" exact component={Setting}/>
        <PrivateRoute path="/setting/profile" exact component={SettingProfile}/>
        <PrivateRoute path="/setting/faq" exact component={SettingFAQ}/>
        <PrivateRoute path="/setting/contactus" exact component={SettingContactUs}/>
        <PrivateRoute path="/setting/aboutus" exact component={SettingAboutUs}/>
        <PrivateRoute path="/setting/userInquiry" exact component={SettingUserInquiry}/>
        <PrivateRoute path="/setting/healthProtocol" exact component={SettingHealthProtocol}/>
        <PrivateRoute path="/setting/support" exact component={SettingSupport}/>
        <PrivateRoute path="/support/chat" hasNavigation={false} exact component={ChatSupport}/>
      </Switch>
    </>
  );
};

export default App;
